import React, { useEffect } from "react";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import { GridStack } from "gridstack";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useTranslation } from "react-i18next";
import Form1Table from "./Form1Table/Form1Table";
import "../ReportEnhanced.css";

const StateFloodReport = () => {
  return (
    <div className="report-enhanced-wrapper">
      <div className="report-header-enhanced">
        <DMSHeader title="Consolidated Report" />
      </div>
      <div className="report-table-enhanced">
        <Form1Table />
      </div>
    </div>
  );
};

export default StateFloodReport;
